<template>
  <path
    d="M12 2.00018C13.1 2.00018 14 2.90018 14 4.00018C14 5.10018 13.1 6.00018 12 6.00018C10.9 6.00018 10 5.10018 10 4.00018C10 2.90018 10.9 2.00018 12 2.00018ZM20 9.00018H15V21.0002C15 21.5502 14.55 22.0002 14 22.0002C13.45 22.0002 13 21.5502 13 21.0002V16.0002H11V21.0002C11 21.5502 10.55 22.0002 10 22.0002C9.45 22.0002 9 21.5502 9 21.0002V9.00018H4C3.45 9.00018 3 8.55018 3 8.00018C3 7.45018 3.45 7.00018 4 7.00018H20C20.55 7.00018 21 7.45018 21 8.00018C21 8.55018 20.55 9.00018 20 9.00018Z"
  />
</template>
